import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

/* CSS */

import '../../shared/components/form/inputDefault.css'

/* form */
import Input from "../../shared/components/form/input"

/* Hooks */
import useMyPermission from '../../hooks/useMyPermission'

import ListSimpleProductRow from './ListRow/ListSimpleProductRow'
import Modal from '../../shared/modal/Modal'
import NewSimpleProduct from './NewSimpleProduct'
import Button from '../../shared/components/Button/Button'


function SimpleProduct({ handleOnSelected, itemData, enableSelectRow, onFinishSelect }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const [simpleProducts, setSimpleProducts] = useState([])
    const [modalNew, setModalNew] = useState(false)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)

    /* ---------------------- Permission ------------------------- */
    const [myPermission, setMyPermission] = useState({ group: "", })
    const { checkPermission } = useMyPermission()
    const myPermissionNew = checkPermission(myPermission, "simpleProduct_create")
    const myPermissionView = checkPermission(myPermission, "simpleProduct_view")
    const myPermissionEdit = checkPermission(myPermission, "simpleProduct_edit")
    const myPermissionDelete = checkPermission(myPermission, "simpleProduct_delete")

    /* get all function */
    const getAll = () => {
        api.get(`/simpleProduct/getall`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                setSimpleProducts(response.data.simpleProducts)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    /* use effect */
    useEffect(() => {
        getAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token])

    /* ----------------------- Search function ---------------------------------- */
    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return simpleProducts.filter((item) => item.description.toLowerCase().includes(searchLowerCase))
    }, [simpleProducts, search])

    function handleSearch(e) {
        setSearch(e.target.value)
    }

    if (!load) {
        return <div className="pg-loading">Carregando produtos simples...</div>
    }

    /* PAGE */
    return myPermissionView ? (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Produtos Simples</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {onFinishSelect && (
                                <Button variant="finish" onClick={onFinishSelect}>Concluir</Button>
                            )}
                            {myPermissionNew && !onFinishSelect && (
                                <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>
                            )}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar por descrição..."
                                    value={search}
                                    handleOnChange={handleSearch}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'produto' : 'produtos'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListSimpleProductRow
                        dataArray={filter}
                        handleOnSuccess={getAll}
                        myPermissionEdit={myPermissionEdit}
                        myPermissionDelete={myPermissionDelete}
                        myPermissionView={myPermissionView}
                        handleOnSelected={handleOnSelected}
                        itemData={itemData}
                        enableSelectRow={enableSelectRow}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum produto simples encontrado</p>
                        <p className="pg-empty-subtitle">
                            {simpleProducts.length === 0
                                ? 'Cadastre o primeiro produto simples para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={96}
                content={
                    <NewSimpleProduct btCancelAction={() => setModalNew(false)} handleOnSuccess={() => { setModalNew(false); getAll() }} />
                }
            />

        </section>
    ) : (
        <div className="pg-empty">
            <p className="pg-empty-title">Sem permissão para visualizar produtos simples</p>
        </div>
    )
}

export default SimpleProduct
